const AI_PREAMBLE_RE =
  /^(?:отлично|хорошо|конечно|разумеется)[^.!\n]*(?:приступаю|составл|подготов|созда)[^.!\n]*[.!]?\s*/i;

const SECTION_MARKERS = [
  '\n\nКлючевые темы',
  '\nКлючевые темы:',
  '\n\nПринятые решения',
  '\nПринятые решения:',
  '\n\nЗадачи',
  '\n\nОткрытые вопросы',
];

export function stripAiPreamble(text: string): string {
  if (!text?.trim()) return '';
  let result = text.trim();
  result = result.replace(AI_PREAMBLE_RE, '');
  result = result.replace(/^\*{2,}\s*$/gm, '').trim();
  const h1 = result.search(/^#\s+/m);
  if (h1 > 0) {
    const prefix = result.slice(0, h1).toLowerCase();
    if (
      prefix.includes('приступаю') ||
      prefix.includes('инструкци') ||
      prefix.includes('терминолог') ||
      prefix.includes('официальн') ||
      prefix.includes('соответствии') ||
      prefix.includes('ktzh')
    ) {
      result = result.slice(h1);
    }
  }
  return result.trim();
}

export function stripMarkdown(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/^[-*•]\s+/gm, '')
    .replace(/`([^`]+)`/g, '$1')
    .trim();
}

export function extractBriefSummary(text: string): string {
  if (!text?.trim()) return '';
  let result = stripMarkdown(text);
  for (const marker of SECTION_MARKERS) {
    const idx = result.indexOf(marker);
    if (idx > 80) result = result.slice(0, idx);
  }
  return result.trim();
}

export function formatChatAnswer(text: string): string {
  if (!text?.trim()) return '';
  const normalized = text
    .replace(/\r\n/g, '\n')
    .replace(/(?<=[.:!?])\s+(\d+\.\s+)/g, '\n$1')
    .replace(/(\n)?(\d+\.\s+\*\*)/g, '\n$2')
    .trim();
  return normalized;
}

export function splitSummaryPoints(text: string, max = 8): string[] {
  const clean = extractBriefSummary(text);
  if (!clean) return [];

  const parts = clean
    .split(/(?<=[.!?])\s+/)
    .map(s => s.trim())
    .filter(s => s.length > 25);

  if (parts.length >= 2) return parts.slice(0, max);

  const fallback = clean
    .split(/\n+/)
    .map(s => s.trim())
    .filter(s => s.length > 25);
  return (fallback.length ? fallback : [clean]).slice(0, max);
}
